/**
 * Offer Approvals API — Pre-offer approval chain.
 */

import { apiFetch } from './core'

export const offerApprovals = {
    list: (params = {}) => {
        const qs = new URLSearchParams(params).toString()
        return apiFetch(`/offer-approvals/${qs ? `?${qs}` : ''}`)
    },
    get: (id) => apiFetch(`/offer-approvals/${id}`),
    submit: (data) => apiFetch('/offer-approvals/', {
        method: 'POST',
        body: JSON.stringify(data),
    }),
    approve: (id, comment = '') => apiFetch(`/offer-approvals/${id}/approve`, {
        method: 'POST',
        body: JSON.stringify({ comment }),
    }),
    reject: (id, comment = '') => apiFetch(`/offer-approvals/${id}/reject`, {
        method: 'POST',
        body: JSON.stringify({ comment }),
    }),
    check: (candidateId, vacancyId) =>
        apiFetch(`/offer-approvals/check/${candidateId}/${vacancyId}`),
}
